import React from 'react';

const FormField = ({ field, value, onChange, isEditable }) => {
  const baseInputClasses = `w-full px-4 py-2 border rounded-lg font-medium transition-all duration-300 ${
    isEditable
      ? 'border-blue-300 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent'
      : 'border-gray-300 bg-gray-50 cursor-not-allowed'
  }`;

  const labelClasses = 'block text-sm font-semibold text-gray-700 mb-2';

  switch (field.type) {
    case 'textarea':
      return (
        <div>
          <label className={labelClasses}>{field.label}</label>
          <textarea
            name={field.name}
            value={value || ''}
            onChange={onChange}
            disabled={!isEditable}
            rows={4}
            className={`${baseInputClasses} resize-none`}
          />
        </div>
      );

    case 'checkbox':
      return (
        <div className="flex items-center gap-3 pt-2">
          <input
            type="checkbox"
            name={field.name}
            checked={value || false}
            onChange={onChange}
            disabled={!isEditable}
            className="w-5 h-5 rounded cursor-pointer accent-blue-500"
          />
          <label className="text-sm font-semibold text-gray-700 cursor-pointer">
            {field.label}
          </label>
        </div>
      );

    case 'select':
      return (
        <div>
          <label className={labelClasses}>{field.label}</label>
          <select
            name={field.name}
            value={value || ''}
            onChange={onChange}
            disabled={!isEditable}
            className={`${baseInputClasses} appearance-none bg-right pr-10`}
            style={{
              backgroundImage: isEditable
                ? `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%230095fa' d='M6 9L1 4h10z'/%3E%3C/svg%3E")`
                : `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%239ca3af' d='M6 9L1 4h10z'/%3E%3C/svg%3E")`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right 12px center',
            }}
          >
            {field.options?.map((option) => (
              <option key={option} value={option}>
                {option || 'Select...'}
              </option>
            ))}
          </select>
        </div>
      );

    case 'date':
      return (
        <div>
          <label className={labelClasses}>{field.label}</label>
          <input
            type="date"
            name={field.name}
            value={value || ''}
            onChange={onChange}
            disabled={!isEditable}
            className={baseInputClasses}
          />
        </div>
      );

    case 'email':
      return (
        <div>
          <label className={labelClasses}>{field.label}</label>
          <input
            type="email"
            name={field.name}
            value={value || ''}
            onChange={onChange}
            disabled={!isEditable}
            className={baseInputClasses}
          />
        </div>
      );

    case 'tel':
      return (
        <div>
          <label className={labelClasses}>{field.label}</label>
          <input
            type="tel"
            name={field.name}
            value={value || ''}
            onChange={onChange}
            disabled={!isEditable}
            className={baseInputClasses}
          />
        </div>
      );

    case 'number':
      return (
        <div>
          <label className={labelClasses}>{field.label}</label>
          <input
            type="number"
            name={field.name}
            value={value || ''}
            onChange={onChange}
            disabled={!isEditable}
            className={baseInputClasses}
          />
        </div>
      );

    case 'password':
      return (
        <div>
          <label className={labelClasses}>{field.label}</label>
          <input
            type="password"
            name={field.name}
            value={value || ''}
            onChange={onChange}
            disabled={!isEditable}
            className={baseInputClasses}
          />
        </div>
      );

    default: // text
      return (
        <div>
          <label className={labelClasses}>{field.label}</label>
          <input
            type="text"
            name={field.name}
            value={value || ''}
            onChange={onChange}
            disabled={!isEditable}
            className={baseInputClasses}
          />
        </div>
      );
  }
};

export default FormField;